export enum LoanOriginationSystemEditTaskActionTypes {
  GetTask = 'loanOriginationSystemEditTask/getTask',
  GetTaskSuccess = 'loanOriginationSystemEditTask/getTaskSuccess',
  GetTaskFailure = 'loanOriginationSystemEditTask/getTaskFailure',
  ResetEditTask = 'loanOriginationSystemEditTask/resetEditTask',
  EditTask = 'loanOriginationSystemEditTask/editTask',
  EditTaskSuccess = 'loanOriginationSystemEditTask/editTaskSuccess',
  EditTaskFailure = 'loanOriginationSystemEditTask/editTaskFailure',
}
